import React from "react";
import { useSelector } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import "./pviReport.css";
import { INSPECTOR_LIST } from "../../data/inspector_data";
import { PVI_CHECKLIST } from "../../data/pvi_data";
import { AFE_CHECKLIST } from "../../data/afe_data";

const PVIReport = () => {
  const pviChecklist = useSelector((state) => state.pvi_list);
  const afeChecklist = useSelector((state) => state.afe_list);
  const { selectedInspectorId } = useSelector((state) => state.ins_info);

  const selectedInspector =
    INSPECTOR_LIST.find((ins) => ins.id === selectedInspectorId) || null;

  const renderCheckSymbol = (checked) => {
    if (checked === true) return <CheckIcon fontSize="small" />;
    if (checked === false) return <CloseIcon fontSize="small" />;
    return <RemoveIcon fontSize="small" />;
  };

  return (
    <div className="pv_icr">
      <img className="report_Logo" src="../images/uEnergy.png" alt="Logo"></img>
      <h1 className="report_title">Solar PV Installation Checklist</h1>

      <div className="c_info">
        <p>{selectedInspector.company}</p>
        <p>{selectedInspector.address}</p>
        <p>{selectedInspector.phone}</p>
        <p>{selectedInspector.email}</p>
      </div>

      {/* Basic_info_section */}
      <ul className="table_sec1">
        <li className="table_col">
          <h1>Refrence No.</h1>
          <h2>REF-2025-001</h2>
        </li>
        <li className="table_col">
          <h1>Installation Address</h1>
          <h2>456 Solar Avenue, Model Town, Lahore, Pakistan</h2>
        </li>
        <li className="table_col">
          <h1>Completed By</h1>
          <h2>Babar Hussain</h2>
          <h1 className="dateTab">Date</h1>
          <h2>15-Oct-2025</h2>
        </li>
      </ul>

      {/* checklist_section */}
      <ul className="table_sec2">
        {PVI_CHECKLIST.map((item, index) => {
          const value = pviChecklist[item.key]; // <- NEW
          return (
            <li className="table_col" key={index}>
              <h1>{item.label}</h1>
              <h2 style={{ color: "gray" }}>{renderCheckSymbol(value)}</h2>
            </li>
          );
        })}
      </ul>

      {/* array_framing_section */}
      <ul className="table_sec2">
        <li className="subHead">Table 2: Array Frame Earthing</li>
        <li className="sec_afe">
          <div className="sec_list">
            {AFE_CHECKLIST.map((item) => (
              <div className="item_info" key={item.key}>
                <h6>{item.question}</h6>
                <h5>
                  <strong>{item.instruction}</strong> {item.details}
                </h5>
                <h4>{renderCheckSymbol(afeChecklist[item.key])}</h4>
              </div>
            ))}
          </div>
          <p className="sec_instruction">
            Tick to confirm if a, b, c, or d apply and complete relevant
            earthing.<br></br>
            <br></br> Apply the most onerous requirements if more than one
            condition in this table applies
          </p>
        </li>
      </ul>

      {/* notes on table 2 */}
      <h4 className="noteHead">Notes on Table 2:</h4>
      <p className="notePoints">
        <strong>NOTE 1: </strong>BS EN 62305 Protection against lightning
        <br></br>
        <strong>NOTE 2: </strong>when considering a) and b) array frames cannot
        be both an extraneous-conductive-part and an exposed-conductive-part,
        because extraneous-conductive-parts are by definition not part of the
        electrical installation whereas exposed-conductive-parts are.<br></br>{" "}
        The requirements described in this diagram apply only to PV arrays
        constructed using electronically conducting and interconnected metallic
        frames. The following mounting structure do not require array frame
        earthing:
      </p>
      <p className="noteSubPoints">
        a) Array mounting structure that are comprised wholly of non-conducting
        materials (for example, plastic, wood etc) and
        <br></br> b) Array mounting assemblies that use discrete metallic
        elements (for example, brackets, bolts etc.) in such a manner that there
        is no electrical path from the frame of one module to another.
      </p>
    </div>
  );
};

export default PVIReport;
